import { TPageConfig } from 'models/common.model'
import { THEMES } from 'root-constants'
import { PageIdWoofzOffer175 } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ_OFFER1_75: Record<
  Exclude<PageIdWoofzOffer175, PageIdWoofzOffer175.ACCOUNT_NOVE8>,
  TPageConfig
> = {
  [PageIdWoofzOffer175.SUBSCRIPTIONS_OFFER1_75]: {
    id: PageIdWoofzOffer175.SUBSCRIPTIONS_OFFER1_75,
    hasHeader: false,
  },
  [PageIdWoofzOffer175.CHAT_UPSELL_OFFER1_75]: {
    id: PageIdWoofzOffer175.CHAT_UPSELL_OFFER1_75,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofzOffer175.UPSELL_OFFER1_75]: {
    id: PageIdWoofzOffer175.UPSELL_OFFER1_75,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofzOffer175.DOWNLOAD_OFFER1_75]: {
    id: PageIdWoofzOffer175.DOWNLOAD_OFFER1_75,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
}
